import { InjectionToken } from '@angular/core';

export const DRAWER_CONTAINER = new InjectionToken('DRAWER_CONTAINER');
